import React, { useRef } from 'react';
import generateFilterServicePackages from '../../../helpers/utils/generateFilterServicePackages';
import Accordion from '../Accordion';
import DropUpArrow from '../Icons/DropUpArrow';
import DropDownArrow from '../Icons/DropDownArrow';
import { IFilterOptions } from '../../../interface/accessories.interface';
import useImpressionPackageServiceList from '../../../hooks/emarsys/package-service/useImpressionPackageServiceList';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import useImpressionCouponServiceList from '../../../hooks/emarsys/coupon-service/useImpressionCouponServiceList';

export interface FilterModalContentServicePackagesProps {
  carModel: IFilterOptions;
  specialOffer: IFilterOptions;
  typeID?: string;
  setTrigger?;
  impressionData?: {
    title: string;
    carModels: string[];
    breadcrumbItems: IBreadcrumbs[];
    customerNo?: string;
    carCategory?: string;
    filterValue?: {
      search: string;
      special_offer: string;
      car_model: string;
      order_by: string;
    };
    sectionName: string;
  };
  feature?: string;
}

export default function FilterModalContentServicePackages({
  carModel,
  specialOffer,
  typeID,
  setTrigger,
  impressionData,
  feature,
}: FilterModalContentServicePackagesProps) {
  const impressionRef = useRef(null);
  const filters = generateFilterServicePackages(
    carModel,
    specialOffer,
    typeID,
    setTrigger,
    impressionData,
    feature
  );

  // Emarsys Impression
  if (typeID === 'package') {
    useImpressionPackageServiceList(
      impressionRef,
      impressionData?.title,
      impressionData?.breadcrumbItems,
      'filter',
      impressionData?.carModels
    );
  }

  if (feature === 'COUPON_SERVICE_LIST') {
    useImpressionCouponServiceList(
      impressionRef,
      impressionData?.title,
      impressionData?.breadcrumbItems,
      'filter',
      impressionData?.carModels
    );
  }

  return (
    <div className="text-reliableBlack w-full" ref={impressionRef}>
      {filters.map((filter, index) => {
        return (
          <Accordion
            key={index}
            classNameSummary={
              '-my-[18px] py-[18px] text-sm text-start font-medium text-reliableBlack cursor-pointer lg:text-base'
            }
            classTitleWrapper={
              'w-full flex justify-between items-center px-4 lg:px-0 font-semibold text-[16px] text-[#231F20]'
            }
            classNameChildrenWrapper={
              'text-start text-sm font-normal text-reliableBlack leading-relaxed lg:text-base lg:leading-relaxed px-4 lg:px-0'
            }
            index={index.toString()}
            title={filter.title === 'Model Kendaraan' ? 'Model Mobil' : filter.title}
            activeIcon={<DropUpArrow />}
            inactiveIcon={<DropDownArrow />}
          >
            {filter.content}
          </Accordion>
        );
      })}
    </div>
  );
}
